const organization = {
    require_membership: "L'utente deve essere un membro dell'organizzazione per procedere.",
    role_names_not_found: 'Nomi di ruoli non validi rilevati: {{names,list(type:conjunction)}}. Si prega di creare prima questi ruoli prima di procedere.',
};
export default Object.freeze(organization);
